import SectionHub from '@/components/docs/SectionHub';

export default function ClientLibrariesPythonSDKHub() {
  return <SectionHub sectionPath="client-libraries/python-SDK" />;
}
